module.exports = __webpack_public_path__ + "static/img/pf.bab3b7a5.svg";